import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import axios from 'axios';

import * as UserActions from 'store/modules/UserModule';

import api from 'lib/api';
import global from 'lib/global';

class NavScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    componentDidMount() {
    }

    onClickGnb = (idx) => {
        this.props.onClickGnb(idx)
    }

    render() {
        const { gnb } = this.props;

        return (
            <div id="nav">
                <h3>Workbook Admin</h3>
                <ul>
                    <li className={gnb == 0 ? 'navOn' : 'navOff'} onClick={() => this.onClickGnb(0)}>Workbook</li>
                    <li className={gnb == 6 ? 'navOn' : 'navOff'} onClick={() => this.onClickGnb(6)}>Paid Resigter</li>
                    <li className={gnb == 8 ? 'navOn' : 'navOff'} onClick={() => this.onClickGnb(8)}>Files</li>
                </ul>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
});

let mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NavScreen);

